export interface MergeVideoParams {
  urls: Array<string>;
  outputSize?: {
    width: number;
    height: number;
  };
  backgroundColor?: string;
}

export interface VideoMergeEvent {
  errorCode: number;
  errorDescription: string;
  outputFilePath: string;
  progress: number;
}

export interface VideoMergeRNRejectError {
  code: string;
  message: string;
  domain: string;
  userInfo: VideoMergeEvent;
}

export type VideoMergeCallbackForOnProgress = (
  progress: number
) => void | Promise<void>;
